<template>
  <div>
    <h1>hi {{ $store.getters.userName }} here are your orders</h1>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>